export default "__VITE_ASSET__DW2mneCQ__"